module.exports = __webpack_public_path__ + "static/media/shallow-focus-of-strawberry-patisseries.731d026c.jpg";